var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "footer-portugal-2020" }, [
    _c("div", { staticClass: "footer-portugal-2020__items" }, [
      _c("figure", { staticClass: "footer-portugal-2020__item" }, [
        _c("figcaption", [_vm._v(_vm._s(_vm.$t("footer_10")))]),
        _vm._m(0)
      ]),
      _vm._m(1),
      _vm._m(2)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          target: "_blank",
          href:
            "https://backoffice.blissapplications.com/media/dhcbmwrt/bliss-apoios.pdf"
        }
      },
      [
        _c("picture", [
          _c("img", {
            staticClass: "lazyload",
            attrs: { "data-src": "/static/images/lisboa-2020.png" }
          })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", { staticClass: "footer-portugal-2020__item" }, [
      _c("figcaption", [_vm._v(" ")]),
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href:
              "https://backoffice.blissapplications.com/media/dhcbmwrt/bliss-apoios.pdf"
          }
        },
        [
          _c("picture", [
            _c("img", {
              staticClass: "lazyload",
              attrs: { "data-src": "/static/images/portugal-2020.png" }
            })
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", { staticClass: "footer-portugal-2020__item" }, [
      _c("figcaption", [_vm._v(" ")]),
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href:
              "https://backoffice.blissapplications.com/media/dhcbmwrt/bliss-apoios.pdf"
          }
        },
        [
          _c("picture", [
            _c("img", {
              staticClass: "lazyload",
              attrs: { "data-src": "/static/images/uniao-europeia.png" }
            })
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-486bdb95", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-486bdb95","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer-portugal-2020-view.vue
// module id = 436
// module chunks = 55